export default function forceFloat(val) {
  if (!val) return 0;

  return parseFloat(val.toString().replace(',', '.'));
}
